import React, { useState } from 'react'
import { View } from 'react-native'

import { pdfjs, Document, Page } from 'react-pdf'

import appStyles from '../../../styles/app-styles'
import Colors from '../../../styles/Colors'
import { PdfThumbnailProps } from '../../../types/PdfThumbnail.types'

// NOTE: Import worker, see: https://github.com/wojtekmaj/react-pdf?tab=readme-ov-file#configure-pdfjs-worker
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  // @ts-ignore
  import.meta.url,
).toString()

export function PdfThumbnail({
  page,
  pdfUrl,
  backgroundColor = Colors['layout.white'],
}: PdfThumbnailProps) {
  const [layout, setLayout] = useState<{ width: number; height: number }>()
  return (
    <View
      style={[appStyles.fullSize, { backgroundColor }]}
      onLayout={e => setLayout(e.nativeEvent.layout)}>
      <Document file={pdfUrl}>
        <Page
          pageNumber={page}
          width={layout?.width}
          height={layout?.height}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>
    </View>
  )
}
